import React, { useEffect, useState } from "react";

import TopBanner from "../../components/layout/TopBanner";
import { useNavigate } from "react-router-dom";
import CustomPopup from "../../components/popup/CustomPopup";
import {
  postCreatePet,
  SearchDogBreed,
  SearchFavoriteProduct,
  SearchPetDetail,
} from "../../services/Dogbook";
// import { tempLineId1 } from "../../services/Api";
import parse from "autosuggest-highlight/parse";
import match from "autosuggest-highlight/match";
import { SearchId } from "../../services/SearchId";
import { useLiff } from "react-liff";
import TopLogoCat from "../../components/layout/TopLogoCat";
import helper from "../../functions/helper";
import dayjs from "dayjs";
import AddDogDetail from "./AddDogDetail";
import AddCatDetail from "./AddCatDetail";

const initialInputValues = {
  urlPicture: null,
  memberId: "",
  petName: "",
  dogBreedId: "",
  birthday: null,
  weight: "",
  favoriteProductId: "",
  isNoti: false,
  lastDateProduct: null,
  openSlide: true,
};

const initialErrorInput = {
  urlPicture: false,
  memberId: false,
  petName: false,
  dogBreedId: false,
  birthday: false,
  weight: false,
  favoriteProductId: false,
  lastDateProduct: false,
};

export default function AddCat() {
  const [isAdded, setIsAdded] = useState(false);
  const navigate = useNavigate();

  const { liff } = useLiff();
  const lineId = liff.getDecodedIDToken().sub;

  const [openCancelPopup, setOpenCancelPopup] = React.useState(false);
  const [memberId, setMemberId] = React.useState(null);
  const [petType, setPetType] = React.useState('cat');

  //api data
  const [dogBreedData, setDogBreedData] = useState([]);
  const [favProductData, setFavProductData] = useState([]);

  const [userInputs, setUserInputs] = useState([{ ...initialInputValues }]);
  const [errorInputs, setErrorInputs] = useState([{ ...initialErrorInput }]);
  let [petDetail, setPetDetail] = useState([]);

  const addDogForm = () => {
    setUserInputs([...userInputs, { ...initialInputValues }]);
    setErrorInputs([...errorInputs, { ...initialErrorInput }]);
  };

  const removeDogForm = (index) => {
    const userInputList = [...userInputs];
    const errorInputList = [...errorInputs];

    userInputList.splice(index, 1);
    errorInputList.splice(index, 1);

    setUserInputs(userInputList);
    setErrorInputs(errorInputList);
  };

  const handleUserInputChange = (
    event,
    index,
    fieldName = null,
    newValue = null
  ) => {
    let { name, value } = event?.target ?? { name: fieldName, value: newValue };
        const updatedUserInputs = [...userInputs];
        const updatedErrorInputs = [...errorInputs];
        updatedUserInputs[index][name] = value;
        updatedErrorInputs[index][name] = value ? false : true;

        setUserInputs(updatedUserInputs);
        setErrorInputs(updatedErrorInputs)
  };

  const toggleOpenSlide = (value, index) => {
    const updatedUserInputs = [...userInputs];
    updatedUserInputs[index]["openSlide"] = value;

    setUserInputs(updatedUserInputs);
  };

  function validateInputs() {
    let valid = true;
    let updatedErrors = [];
    for (var index = 0; index < userInputs.length; index++) {
      let updatedError = {
        // urlPicture: userInputs[index].urlPicture !== null ? false : true,
        petName: userInputs[index].petName !== "" ? false : true,
        dogBreedId: userInputs[index].dogBreedId !== "" ? false : true,
        birthday: userInputs[index].birthday !== null ? false : true,
        weight: userInputs[index].weight !== "" ? false : true,
        favoriteProductId:
          userInputs[index].favoriteProductId !== "" ? false : true,
        lastDateProduct:
          userInputs[index].lastDateProduct !== null ? false : true,
      };
      updatedErrors.push(updatedError);
      valid = !Object.values(updatedError).some((field) => field);
    }

    setErrorInputs(updatedErrors);

    return valid;
  }

  useEffect(() => {
    getSearchId();
  }, []);

  async function getSearchId() {
    return await SearchId({
      params: { lineId: lineId || null , species: 2},
    })
      .then(async (response) => {
        if (!response.data.body.memberId) {
          window.location.replace("/register-cat");
        } else {
          getPetDetail(response.data.body.memberId);
          setMemberId(response.data.body.memberId);
        }
      })
      .catch((error) => {
        console.log(error);
      });
  }


  async function getFavProduct() {
    return await SearchFavoriteProduct({
      // params: { lineId: tempLineId1 },
    })
      .then(async (response) => {
        setFavProductData(response.data.body);
      })
      .catch((error) => {
        console.log(error);
      });
  }

  async function createPet() {
    if (validateInputs()) {
      console.log("pass");
    } else {
      console.log("failed");
      return;
    }

    userInputs.forEach(async (userInput) => {
      helper.toImageSmall();
      const payload = {
        ...userInput,
        urlPicture: userInput.urlPicture
          ? await helper.toImageSmall(userInput.urlPicture)
          : null,
        memberId: memberId,
        isNoti: userInput.lastDateProduct ? true : false,
        birthday: helper.postUTC(userInput.birthday),
        notifyTime: (() => {
          if (userInput.lastDateProduct) {
            const _lastDateProduct = dayjs(userInput.lastDateProduct).add(
              0,
              "month"
            );
            return helper.postUTC(_lastDateProduct);
          }
          return null;
        })(),
      };
      console.log("payload >>", payload);
      delete payload.openSlide;

      try {
        const { data } = await postCreatePet({ data: payload });
        console.log("resData.data >>", data);
        if (data.resultCode === 20000) {
          setIsAdded(true);
          console.log("resData.data >>", data.body);
        }
      } catch (error) {
        console.log("create pet error", error);
      }
    });
  }

  function fnRenderOption(props, option, { inputValue }) {
    const breed1 = `${option.name}`;

    const matches1 = match(breed1, inputValue, { insideWords: true });
    const parts1 = parse(breed1, matches1);

    return (
      <li {...props} className="text-left pl-1 border-address-list">
        <div>
          {parts1.map((part, index) => (
            <span
              key={index}
              style={{
                fontWeight: part.highlight ? 700 : 400,
                color: part.highlight ? "#0A4197" : "#8F8F8F",
              }}
            >
              {part.text}
            </span>
          ))}
        </div>
      </li>
    );
  }

  const handleImage = (event, index) => {
    const file = event.target.files[0];
    const reader = new FileReader();
    reader.onloadend = () => {
      const updatedUserInputs = [...userInputs];
      updatedUserInputs[index]["urlPicture"] = reader.result.substring(
        reader.result.indexOf(",") + 1
      );

      setUserInputs(updatedUserInputs);
    };
    reader.readAsDataURL(file);
  };

  const yesterday = new Date();

  return (
    <div id="adddog-page">
      <CustomPopup
        title={"ยกเลิกการเพิ่มน้องหมา"}
        desc={
          "คุณกำลังยกเลิกการเพิ่มข้อมูลของน้องหมาตัวใหม่ หากกด ยืนยัน แล้วข้อมูลของน้องหมาจะไม่ถูกบันทึก"
        }
        cancelFunction={() => {
          setOpenCancelPopup(false);
        }}
        actionFunction={() => {
          navigate(-1);
          setOpenCancelPopup(false);
        }}
        open={openCancelPopup}
        onClose={() => {
          setOpenCancelPopup(false);
        }}
      />

      <div>
        <TopLogoCat />
        <TopBanner type="catbook" />
        <div
          id="add-btn" className="flex justify-center bg-white px-[20px] pt-[16px] pb-[24px] mx-[20px]"
        >
          <button
            onClick={() => setPetType('cat')}
            className={petType === 'cat' ? 'catBookAddBtnActive' : 'catBookAddBtn'}
            style={{ marginRight: "5px" }}
          >
            <p className="text-[16px] text-center  mt-[-2px]">
              เพิ่มน้องแมว
            </p>
          </button>
          <button
            onClick={() => setPetType('dog')}
            className={petType === 'dog' ? 'catBookAddBtnActive' : 'catBookAddBtn'}
           
          >
            <p className="text-[16px] text-center mt-[-2px]">
              เพิ่มน้องหมา
            </p>
          </button>
        </div>
        {petType === 'dog' ? <AddDogDetail></AddDogDetail> :
          <AddCatDetail></AddCatDetail>
        }

      </div>

    </div>
  );
}
